const state = {
	websocketMessage: "", // 端返回的信息
	socketTimestamp: new Date().getTime(), //时间戳去监听数据的改变
}
const mutations = {
	setSocketMessage(state, data) { //一旦获取到端端返回的信息，就改变时间戳
		state.socketTimestamp = new Date().getTime();
		state.websocketMessage = data;
	},
}
const actions = {

}
export default {
}
